"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserMenuSeparator = exports.UserMenuItem = exports.UserMenuItems = exports.SideUserMenu = exports.SideUserMenuControl = exports.TopUserMenu = exports.TopUserMenuControl = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _index = require("../index");

var _utils = require("../utils");

var _withTheme = require("../../wrappers/with-theme");

var _withAuth = _interopRequireDefault(require("../../wrappers/with-auth"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TopUserMenuControl = function TopUserMenuControl(_ref) {
  var _ref$open = _ref.open,
      open = _ref$open === void 0 ? false : _ref$open,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      props = _objectWithoutProperties(_ref, ["open", "className", "style"]);

  var theme = (0, _withTheme.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, props, {
    className: "\n        flex items-center rounded cursor-pointer ".concat(theme.textInfo, "\n        ").concat(open ? theme.borderInfo : "border-transparent", "\n        hover:").concat(theme.borderInfo, " ").concat(theme.transition, "\n        flex items-center justify-center ").concat(className, "\n      "),
    style: _objectSpread({
      width: "2.5rem",
      height: "2.5rem",
      borderRadius: "1.25rem",
      fontSize: "1.15rem",
      borderWidth: "3px"
    }, style)
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "fas fa-user"
  }));
};

exports.TopUserMenuControl = TopUserMenuControl;
var TopUserMenu = (0, _withAuth["default"])(function (_ref2) {
  var user = _ref2.user;

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1],
      toggle = _react["default"].useCallback(function (e) {
    setOpen(function (open) {
      return !open;
    });
  }, []),
      clickedOutside = _react["default"].useCallback(function () {
    return setOpen(false);
  }, []),
      _useClickOutside = (0, _utils.useClickOutside)(clickedOutside),
      _useClickOutside2 = _slicedToArray(_useClickOutside, 1),
      setRef = _useClickOutside2[0],
      theme = (0, _withTheme.useTheme)();

  var _useComponents = (0, _index.useComponents)(),
      UserMenuItems = _useComponents.UserMenuItems,
      TopUserMenuControl = _useComponents.TopUserMenuControl;

  return !user ? null : !user.authed ? /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: "/auth/login"
  }, /*#__PURE__*/_react["default"].createElement(TopUserMenuControl, null)) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative",
    ref: setRef
  }, /*#__PURE__*/_react["default"].createElement(TopUserMenuControl, {
    open: open,
    onClick: toggle
  }), !open ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n              ".concat(theme.menuBg, " ").concat(theme.menuText, "\n              p-2 right-0 absolute\n            "),
    style: {
      top: "100%",
      minWidth: "8rem"
    }
  }, /*#__PURE__*/_react["default"].createElement(UserMenuItems, {
    toggle: toggle
  })));
});
exports.TopUserMenu = TopUserMenu;

var SideUserMenuControl = function SideUserMenuControl(_ref3) {
  var _ref3$open = _ref3.open,
      open = _ref3$open === void 0 ? false : _ref3$open,
      _ref3$label = _ref3.label,
      label = _ref3$label === void 0 ? "" : _ref3$label,
      _ref3$className = _ref3.className,
      className = _ref3$className === void 0 ? "" : _ref3$className,
      _ref3$style = _ref3.style,
      style = _ref3$style === void 0 ? null : _ref3$style,
      props = _objectWithoutProperties(_ref3, ["open", "label", "className", "style"]);

  var theme = (0, _withTheme.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, props, {
    className: "\n        w-full py-1 pl-4 transition cursor-pointer\n        ".concat(theme.menuBgHover, " ").concat(theme.menuTextHover, " ").concat(className, "\n      "),
    style: style
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "fas fa-user mr-2"
  }), label);
};

exports.SideUserMenuControl = SideUserMenuControl;
var SideUserMenu = (0, _withAuth["default"])(function (_ref4) {
  var user = _ref4.user;

  var _React$useState3 = _react["default"].useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      open = _React$useState4[0],
      setOpen = _React$useState4[1],
      toggle = _react["default"].useCallback(function () {
    setOpen(function (open) {
      return !open;
    });
  }, []),
      clickedOutside = _react["default"].useCallback(function () {
    return setOpen(false);
  }, []),
      _useClickOutside3 = (0, _utils.useClickOutside)(clickedOutside),
      _useClickOutside4 = _slicedToArray(_useClickOutside3, 1),
      setRef = _useClickOutside4[0],
      theme = (0, _withTheme.useTheme)();

  var _useComponents2 = (0, _index.useComponents)(),
      SideUserMenuControl = _useComponents2.SideUserMenuControl,
      UserMenuItems = _useComponents2.UserMenuItems;

  return !user ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "pb-6"
  }, !user.authed ? /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: "/auth/login"
  }, /*#__PURE__*/_react["default"].createElement(SideUserMenuControl, {
    label: "Login"
  })) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative",
    ref: setRef
  }, /*#__PURE__*/_react["default"].createElement(SideUserMenuControl, {
    label: "User Menu",
    open: open,
    onClick: toggle
  }), !open ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n                  ".concat(theme.menuBg, " ").concat(theme.menuText, " mt-1 p-2 left-0 absolute\n                "),
    style: {
      bottom: "100%",
      minWidth: "8rem"
    }
  }, /*#__PURE__*/_react["default"].createElement(UserMenuItems, {
    toggle: toggle
  }))));
});
exports.SideUserMenu = SideUserMenu;
var UserMenuItems = (0, _withAuth["default"])(function (_ref5) {
  var _ref5$user = _ref5.user,
      user = _ref5$user === void 0 ? {} : _ref5$user,
      toggle = _ref5.toggle;

  var _useComponents3 = (0, _index.useComponents)(),
      UserMenuSeparator = _useComponents3.UserMenuSeparator,
      UserMenuItem = _useComponents3.UserMenuItem;

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-1 border-b-2"
  }, user.email), /*#__PURE__*/_react["default"].createElement(UserMenuItem, {
    to: "/auth/profile",
    toggle: toggle
  }, "Profile"), (0, _lodash["default"])(user, "authLevel", -1) < 5 ? null : /*#__PURE__*/_react["default"].createElement(UserMenuItem, {
    to: "/auth/project-management",
    toggle: toggle
  }, "Project Management"), /*#__PURE__*/_react["default"].createElement(UserMenuSeparator, null), /*#__PURE__*/_react["default"].createElement(UserMenuItem, {
    to: "/auth/logout",
    toggle: toggle
  }, "Logout"));
});
exports.UserMenuItems = UserMenuItems;

var UserMenuItem = function UserMenuItem(_ref6) {
  var _ref6$to = _ref6.to,
      to = _ref6$to === void 0 ? "#" : _ref6$to,
      toggle = _ref6.toggle,
      children = _ref6.children;
  var theme = (0, _withTheme.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    onClick: toggle
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: to
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n          rounded cursor-pointer px-2 whitespace-nowrap\n          ".concat(theme.menuBg, " ").concat(theme.menuBgHover, "\n          ").concat(theme.menuText, " ").concat(theme.menuTextHover, "\n        ")
  }, children)));
};

exports.UserMenuItem = UserMenuItem;

var UserMenuSeparator = function UserMenuSeparator() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "border my-1"
  });
};

exports.UserMenuSeparator = UserMenuSeparator;